import * as React from 'react';
import O365OrganizationConnectControl from '../../../../integration/Office365/Organization/O365OrganizationConnectControl';
import { AuthProvider, AuthProvidersMap, Dictionary, PANEL_CUSTOM_WIDTH } from '../../../../../entities/common';
import { Panel, PanelType } from 'office-ui-fabric-react';
import { SystemButton } from '../../../../integration/SystemsList';
import { SourceType } from '../../../../../store/ExternalEpmConnectStore';
import OktaOrganizationConnectControl from '../../../../integration/Okta/Organization/OktaOrganizationConnectControl';

type OwnProps = {
    actions: Dictionary<any>;
    sources: AuthProvider[];
    selected?: AuthProvider;
    dismissPanel: () => void;
}

type ConnectProps = { actions: any; dismissPanel: () => void; }
type RendersMap = { [key in AuthProvider]?: (props: ConnectProps) => JSX.Element } & { types: AuthProvider[] }

const rendersMap: RendersMap = {
    [AuthProvider.o365]: _ => <O365OrganizationConnectControl {..._} />,
    [AuthProvider.okta]: _ => <OktaOrganizationConnectControl {..._} />,
    types: [AuthProvider.o365]
}

const OrganizationLinkPanel = (props: OwnProps) => {
    const [selectedConnector, setSelectedConnector] = React.useState<AuthProvider>(props.selected ?? props.sources?.[0]);

    const onRenderHeader = React.useCallback(() => (
        <div className="ms-Panel-header">
            <p className="ms-Panel-headerText">Link Organization</p>
            <div className='ms-Panel-secondaryText'>Select the organization type for linking to your PPM Express tenant.</div>
        </div>), []
    );
    
    const renderConnectControl = React.useCallback((connector: AuthProvider) => {
        return rendersMap[connector]?.({
            actions: props.actions[connector],
            dismissPanel: props.dismissPanel,
        });
    }, [rendersMap, props.actions, props.dismissPanel]);

    return <Panel
        isLightDismiss
        type={PanelType.custom}
        customWidth={PANEL_CUSTOM_WIDTH}
        className="connect-panel"
        isOpen={true}
        onDismiss={props.dismissPanel}
        onRenderHeader={onRenderHeader}>
        <div className="system-connect-buttons-list">
            {props.sources.map(_ =>
                <SystemButton
                    key={_}
                    system={{
                        type: _ === AuthProvider.o365 ? SourceType.O365User : undefined,
                        text: AuthProvidersMap[_].friendlyName,
                        isConnected: props.selected === _,
                    }}
                    iconName={_ === AuthProvider.okta ? "OktaLogo" : undefined}
                    isSelected={selectedConnector === _}
                    onSelect={() => setSelectedConnector(_)} />
            )}
        </div>
        {selectedConnector !== undefined && renderConnectControl(selectedConnector)}
    </Panel>;
}

export default OrganizationLinkPanel;